export const AUTHED_QUERY_TAG = 'authed_query';

export const QUERY_KEYS = {
  EXCHANGES: 'exchanges',
  EXCHANGES_WITH_API_KEYS: 'exchanges-with-api-keys',
  ENROLLED_EXCHANGES: 'enrolled-exchanges',
  ALL_CAMPAIGNS: 'all-campaigns',
  HOSTED_CAMPAIGNS: 'hosted-campaigns',
  JOINED_CAMPAIGNS: 'joined-campaigns',
  CAMPAIGN_DETAILS: 'campaign-details',
  CAMPAIGNS_STATS: 'campaigns-stats',
  TOTAL_VOLUME: 'total-volume',
  TRADING_PAIRS: 'trading-pairs',
  EXCHANGE_CURRENCIES: 'exchange-currencies',
  USER_PROGRESS: 'user-progress',
  CHECK_CAMPAIGN_JOIN_STATUS: 'check-campaign-join-status',
  LEADERBOARD: 'leaderboard',
  USER_INFO: 'user-info',
};
